import React from 'react';
import { Logo } from '../shared/simple/Logo';
import { RouterLink } from '../shared/simple/RouterLink';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { routes } from '../../constants/routes';
import { logoBgAppOrigin, appsOrigin } from '../../constants/appOrigin';

// Define element styles for the component
const LinkStyled = styled(RouterLink)`
  height: 100px;
  max-width: 350px;
  margin: 30px !important;
`;

/**
 * LinkLogo component
 * @component
 * @returns
 */
export const LinkLogo = () => {
  const { infoProductRequest, selectedProduct } = useSelector(state => state.user);
  const image_main = infoProductRequest?.image_main || logoBgAppOrigin.default;
  const image_main_auth = selectedProduct?.image_main || logoBgAppOrigin.default;
  return (
    <RouterLink
      className="p-0 col-12 link-logo"
      to={routes.login(appsOrigin.default)}
    >
      <Logo
        className="d-none d-md-block"
        src={ infoProductRequest ? image_main : image_main_auth }
        name={`img_${infoProductRequest ? infoProductRequest?.application?.unique_name : !selectedProduct?.application ? "wisenroll" : selectedProduct.application?.unique_name}`}
      />
    </RouterLink>
  );
};